<template>
    <div class="container">
        <div class="header">
            <div class="header-top">
                <div class="avatar"></div>
                <div class="header-top-right">
                    <div class="title">{{lan.title}}</div>
                    <div class="subtitle">{{lan.subtitle}}</div>
                </div>
            </div>
            <div class="header-bottom">
                {{lan.desc}}
            </div>
        </div>
        <div class="content-wrap">
            <div class="content">
                <textarea class="desc-area" :placeholder="lan.placeholder" @input="textAreaChange" maxlength="140" @blur="handleBlur"></textarea>
                <div class="contact-panel">
                    <div class="contact">{{lan.contact}}</div>
                    <div class="type">{{lan.type}}</div>
                </div>
                <input class="contact-input" :placeholder="lan.contactPlaceholder" @input="contactChange" @blur="handleBlur" />
                <div v-if="disable" class="submit-button disable">{{lan.submit}}</div>
                <div v-else class="submit-button" @click="submit">{{lan.submit}}</div>
            </div>
        </div>

        <transition name="fade">
            <div v-if="isRequesting" class="mask">
                <div class="toast">
                    <div class="toast-img">
                        <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                        </svg>
                    </div>
                    <div class="toast-text">{{lan.sending}}</div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div v-if="showError" class="mask1">
                <div class="toast">
                    <div class="toast-text">{{errorMsg}}</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import Utils from '../../common/Utils'
import md5 from '../../common/md5'
import lan from '../../common/lan'
import Server from '../../common/Server'

/**
 * 获取url上的参数
 * @param name
 */
const getQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window
        .location
        .search
        .substr(1)
        .match(reg);
    if (r != null)
        return unescape(r[2]);
    return null;
}

export default {
    name: 'feedBack',
    data () {
        return {
            textAreaValue: '',
            contactValue: '',
            disable: true,
            lan: lan[getQueryString("lan")]?lan[getQueryString("lan")]:lan["en"],
            appName: getQueryString("appName"),
            isRequesting: false,
            showError: false,
            errorMsg: 'test'
        }
    },

    mounted() {
        if (this.$data.appName == "inFace") {
            this.$data.lan = lan[this.$data.appName + "-" + getQueryString("lan")]?lan[this.$data.appName + "-" + getQueryString("lan")]:lan[this.$data.appName + "-en"]
        }
    },

    methods: {

        calSign(params) {
            let str = `appName=${params.appName}&contact=${params.contact}&content=${params.content}inface#mail!queue^`
            return md5(str) 
        },

        handleBlur() {
            setTimeout(() => {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
                window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            }, 100)
        },

        submit: function() {

            const publicInfo = getQueryString("publicInfo")
            
            let params = {
                appName: this.$data.appName,
                content: this.$data.textAreaValue + (publicInfo?publicInfo:''),
                contact: this.$data.contactValue
            }
            let sign = this.calSign(params)
            let data = Object.assign(params, {sign})

            if (!this.$data.isRequesting) {
                this.$data.isRequesting = true
                Server.post('/api/mail-queue/infaceFeedback', data)
                .then((response) => {
                    this.$data.isRequesting = false
                    this.$router.push('/success')
                })
                .catch((error) => {
                    this.$data.isRequesting = false
                    this.$data.showError = true
                    this.$data.errorMsg = this.$data.lan.fail
                    setTimeout(() => {
                        this.$data.showError = false
                        this.$data.errorMsg = ""
                    }, 2500)
                })
            }

        },

        textAreaChange: function(e) {
            let value = Utils.trim(e.target.value)
            if (value.length > 0 && this.$data.contactValue.length > 0) {
                this.$data.disable = false
            }else {
                this.$data.disable = true
            }
            this.$data.textAreaValue = value
        },

        contactChange: function(e) {
            let value = Utils.trim(e.target.value)
            if (value.length > 0 && this.$data.textAreaValue.length > 0) {
                this.$data.disable = false
            }else {
                this.$data.disable = true
            }
            this.$data.contactValue = value
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

input, textarea {
    border: none;
    margin: none;
    padding: 0 auto;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    outline: none;
}

input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: rgba(51, 51, 51, 0.3);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.container {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    color: black;
    background: white;
}

.mask {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: white;
    opacity: 0.4;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.mask1 {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.toast {
    padding: 0 20px 0 20px;
    min-width: 126px;
    height:66px;
    background:rgba(29,28,28,0.7);
    border-radius:2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    flex-direction: row;
}

.toast-img {
  width: 24px;
  height: 24px;
}

.circular {
  animation: rotate 2s linear infinite;
  height: 24px;
  width: 24px;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@keyframes color {
  100%,
  0% {
    stroke: #f1483b;
  }
  40% {
    stroke: #6d9de9;
  }
  66% {
    stroke: #48d890;
  }
  80%,
  90% {
    stroke: #ffa700;
  }
}

.toast-text {
    color: white;
    font-size: 14px;
    text-align: center;
    margin: 0 0 0 5px;
}

.header {
    width: 100%;
    height: auto;
    position: relative;
    border-top: 1px solid transparent;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.header-top {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 20px 0 0 0;
}

.header-top-right {
    flex: 2;
    height: 100%;
    margin: 0 0 0 10px;
    color: #333333;
    font-size: 16px;
    text-align: left;
    font-weight: 500;
}

.avatar {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background: rgb(199, 199, 199);
    margin:0 0 0 16px;
    background-image: url(../../assets/avatar.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.header-bottom {
    width: 100%;
    height: auto;
    margin: 12px 0 0 0;
    font-size: 14px;
    color: #333333;
    text-align: left;
    white-space: normal;
    word-break: break-all;
    word-wrap : break-word;
    padding: 0 16px 0 16px;
    box-sizing: border-box;
}

.content-wrap {
    display: flex;
    flex-direction: row;
    flex: 1;
    padding: 0 16px;
}

.side {
    width: 16px;
    height: 100px;
}

.content {
    flex: 1;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.desc-area {
    width: 100%;
    flex: 1;
    border-radius: 2px;
    margin: 24px 0 0 0;
    background:#F6F6F6;
    resize: none;
    padding: 14px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
}

.contact-panel{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 20px;
    line-height: 20px;
    margin: 24px 0 0 0;
}

.contact {
    font-size: 14px;
    color: #333333;
    font-weight: bold
}

.type {
    font-size: 14px;
    color: #333333;
}

.contact-input {
    width: 99%;
    height: 48px;
    background: #f6f6f6;
    border-radius: 2px;
    margin: 10px 0 0 0;
    text-indent: 14px;
    font-size: 14px;
    color: #333333;
}

.submit-button {
    width:238px;
    height:50px;
    line-height: 50px;
    border-radius:2px;
    background-image: linear-gradient(to right, #474747 , #282828);
    color:#e5c9b6;
    font-size: 16px;
    font-weight: bold;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, .2);
    margin: 60px 0 20px 0;
}

.submit-button.disable {
    opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// src/page/feedBack/FeedBack.vue